import { createFileRoute } from '@tanstack/react-router';
import { LeaveList } from '@/components/company/leave/leave-list';

export const Route = createFileRoute('/(app)/company/leave/')({
  component: CompanyLeaveRoute,
});

function CompanyLeaveRoute() {
  return <LeaveList />;
}
